/** Fase 2 — minimaal DNA vóór AI-template generatie. */
export function assessBrandDnaForTemplateAi(dna) {
    const missing = [];
    const tone = (dna?.tone_of_voice ?? '').trim() || (dna?.writing_style ?? '').trim();
    if (!tone)
        missing.push('tone of voice of schrijfstijl');
    if (!(dna?.target_audience_summary ?? '').trim())
        missing.push('doelgroep (samenvatting)');
    const props = (dna?.value_props ?? []).filter((p) => p.trim().length > 0);
    if (props.length === 0)
        missing.push('minstens één waardepropositie');
    return { ok: missing.length === 0, missing };
}
//# sourceMappingURL=brandDnaTemplateReadiness.js.map